import ajax from "../../components/ajax";
import { addGlobalLiveEventListener, startIconLoading, stopIconLoading } from "../../utils";
import { StatusClassNames } from "../../types/StatusClassNames";
import $ from '../../vendor/dom7';
function initSortingToggle() {
    const btn = document.getElementById('reviews-sorting-btn');
    const dialog = document.getElementById('reviews-sorting');
    if (!btn || !dialog) {
        return;
    }
    btn.addEventListener('click', () => dialog.open ? dialog.close() : dialog.show());
}
export default function initReviews() {
    // голосование за отзывы о товаре
    addGlobalLiveEventListener('click', ['.review-votes__btn--up', '.review-votes__btn--down'], async function () {
        const id = parseInt(this.dataset.id);
        startIconLoading(this);
        const data = await ajax('/ajax/act_vote.php', { id, vote: this.matches('.review-votes__btn--up') ? 1 : 2 })
            .then(response => response.text());
        const [plus, minus] = data.split('_');
        $(`.review-votes__btn--up[data-id="${id}"]`).parents('.stats-item').find('.stats-item__label').text(plus);
        $(`.review-votes__btn--down[data-id="${id}"]`).parents('.stats-item').find('.stats-item__label').text(minus);
        document.querySelectorAll(`.review-item__voting [data-id="${id}"]`).forEach(el => el.classList.remove(StatusClassNames.pressed));
        this.classList.add(StatusClassNames.pressed);
        stopIconLoading(this);
    });
    initSortingToggle();
}
